import { useState, useEffect } from "react";

const InAppBrowserBanner = () => {
  const [isInApp, setIsInApp] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    if (typeof navigator === "undefined") return;
    const ua = navigator.userAgent || navigator.vendor || window.opera || "";
    const isFBOrInsta = /FBAN|FBAV|FB_IAB|Instagram/i.test(ua);
    const isDroid = /Android/i.test(ua);

    setIsAndroid(isDroid);
    setIsInApp(isFBOrInsta);
  }, []);

  if (!isInApp || isDismissed) return null;

  const handleOpenInBrowser = () => {
    if (isAndroid) {
      const cleanHostAndPath = `${window.location.host}${window.location.pathname}${window.location.search}`;
      window.location.href = `intent://${cleanHostAndPath}#Intent;scheme=https;package=com.android.chrome;end`;
    } else {
      alert("बेहतर अनुभव के लिए: ऊपर दाएँ कोने में 3 डॉट्स (•••) पर टैप करें और 'Open in Safari / Browser' चुनें।");
    }
  };

  return (
    <div className="bg-gradient-to-r from-blue-700 to-indigo-800 text-white px-4 py-2.5 shadow-md flex items-center justify-between text-xs sm:text-sm z-40 relative">
      <div className="flex items-center gap-2 pr-2">
        <i className="fa-solid fa-compass text-amber-300 text-base"></i>
        <span>
          {isAndroid
            ? "तेज़ लोडिंग और सभी फीचर्स के लिए Chrome में खोलें:"
            : "बेहतर अनुभव के लिए दाएँ कोने में 3 डॉट्स (•••) दबाकर 'Open in Safari' चुनें"}
        </span>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        {isAndroid && (
          <button
            onClick={handleOpenInBrowser}
            className="bg-white text-blue-800 font-bold px-3 py-1 rounded-full hover:bg-gray-100 active:scale-95 transition whitespace-nowrap shadow-sm text-xs"
          >
            Chrome में खोलें
          </button>
        )}
        <button
          onClick={() => setIsDismissed(true)}
          className="text-white/80 hover:text-white p-1"
          aria-label="Dismiss banner"
        >
          <i className="fa-solid fa-xmark text-sm"></i>
        </button>
      </div>
    </div>
  );
};

export default InAppBrowserBanner;
